/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_No_UpcomingInputs */



/**
* | output |
* | --- |
* | "No upcoming invoice. Your first invoice will appear after the current billing period." |
*
* @param {Billing_No_UpcomingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_no_upcoming = /** @type {((inputs?: Billing_No_UpcomingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_No_UpcomingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine anstehende Rechnung. Ihre erste Rechnung erscheint nach dem aktuellen Abrechnungszeitraum.")
	return /** @type {LocalizedString} */ ("No upcoming invoice. Your first invoice will appear after the current billing period.")
});